import { Link } from "react-router-dom";
import { LegalPage, LegalSection, LegalList, COMPANY } from "./LegalPage";

export default function Cookie() {
  return (
    <LegalPage
      testid="cookie-page"
      eyebrow="Legale"
      title="Cookie Policy"
      intro="La presente Cookie Policy descrive i cookie utilizzati dal sito ViviTranquillo.com."
    >
      <LegalSection title="Cookie utilizzati">
        <p>
          ViviTranquillo.com utilizza <strong>esclusivamente cookie tecnici</strong> e strumenti di archiviazione locale
          (localStorage) strettamente necessari al funzionamento del sito e dei servizi, in particolare per
          l'autenticazione e il mantenimento della sessione nell'Area Clienti.
        </p>
        <LegalList
          items={[
            "Cookie / archiviazione tecnica di sessione: necessari per l'accesso e la navigazione sicura nell'Area Clienti.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Cookie non tecnici">
        <p>
          Il sito <strong>non utilizza</strong> cookie di analytics, statistici di terze parti o di profilazione.
          Poiché sono presenti solo cookie tecnici, non è richiesto il consenso preventivo dell'utente e non viene
          mostrato alcun banner di consenso.
        </p>
        <p>
          Qualora in futuro vengano introdotti cookie analytics o di profilazione non tecnici, verrà predisposto un
          banner di consenso con le opzioni <strong>Accetta</strong>, <strong>Rifiuta</strong> e{" "}
          <strong>Gestisci preferenze</strong>, e nessun tracciamento non necessario verrà attivato prima del consenso.
        </p>
      </LegalSection>

      <LegalSection title="Gestione dei cookie">
        <p>
          L'utente può eliminare o bloccare i cookie tecnici tramite le impostazioni del proprio browser; la
          disattivazione dei cookie tecnici può tuttavia compromettere l'accesso all'Area Clienti e il corretto
          funzionamento dei servizi.
        </p>
      </LegalSection>

      <LegalSection title="Contatti">
        <p>
          Per informazioni sui cookie è possibile contattare {COMPANY.name} all'indirizzo {COMPANY.email}. Maggiori
          dettagli sul trattamento dei dati sono disponibili nella{" "}
          <Link to="/privacy" className="font-semibold text-[#10B981] hover:underline">Privacy Policy</Link>.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
